import { useLang } from 'hooks/lang';

import { recruitmentStatusConfig, actions } from 'entities';

import { Button, Card, LabeledTextarea } from 'components/Blocks';

import { XBookIcon } from 'components/Icons';

import { useSingleConfirmation } from 'providers/Confirmation';
import { useFormControl } from 'hooks';
import { useRecruitmentModal } from './context';

export function DenyRecruitment() {
  const { t } = useLang();
  const { recruitment, updateRecruitment, setTab } = useRecruitmentModal();

  const { state, handleChange } = useFormControl({
    justification: '',
  });

  const canSubmit = !!state.justification.trim();

  const denyRecruitment = actions.projects.denyRecruitment.use({
    block: !canSubmit,

    params: {
      recruitmentId: recruitment!.id,
      ...state,
    },

    onSuccess: () => {
      updateRecruitment({
        ...recruitment!,
        status: recruitmentStatusConfig.denied.code,
      });

      setTab('main');
    },
  });

  const requestFinish = useSingleConfirmation({
    onConfirm: denyRecruitment.onClick,

    type: 'irreversible',
  });

  return (
    <Card flow="column">
      <LabeledTextarea
        label={t('justification')!}
        name="justification"
        value={state.justification}
        onChange={handleChange}
        loading={denyRecruitment.loading}
      />

      <Button
        onClick={requestFinish}
        loading={denyRecruitment.loading}
        disabled={!canSubmit}
        variant="outlined"
        className="ml-auto w-fit"
        color="destructive"
      >
        <XBookIcon size={20} />
        {t('deny-recruitment')}
      </Button>
    </Card>
  );
}
